// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .register-container{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 50px 0;
} */
.register-wrapper h2 {
  font-size: var(--f45);
  font-weight: 700;
  color: var(--dBlue);
  text-align: left !important;
}
.register-wrapper {
  /* width: 40%; */
  padding: 50px;
  /* box-shadow: 0px 0px 8px -3px #ccc; */
  border-radius: 8px;
}
.register-wrapper h2 span {
  color: var(--dPink);
}
.register-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.register-wrapper button {
  /* width: 30%; */
  padding: 10px 25px;
  background: var(--dBlue);
  border: none;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 2px;
  border-radius: 0;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 30px;
}
.register-wrapper input,
.register-wrapper select {
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  border: none;
  border-radius: 50px;
  border: 2px solid #c3c5f8;
}
.register-wrapper form input,
.register-wrapper form select {
  padding: 10px 20px !important;
  width: 100%;
  color: #000 !important;
}

.register-wrapper h4 {
  font-size: 20px;
  margin-bottom: 20px;
  text-transform: capitalize;
  color: var(--dBlue);
}
.register_login_signup {
  background: rgb(195 197 248 / 10%);
}
.register_icons div {
  display: block;
  margin: 0 auto;
  padding: 40px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background: #f9f9fe;
  border: 2px solid #c3c5f8;
  border-radius: 50%;
  text-align: center;
  margin-top: -50px;
}
.register_icons {
  border: 2px solid #c3c5f8;
  padding: 0px 20px 40px;
  border-radius: 15px;
}
.register_icons svg {
  color: var(--dPink);
}
.register_icons h5 {
  color: var(--dBlue);
  font-weight: 700;
  font-size: 24px;
  margin: 15px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/register/Register.css"],"names":[],"mappings":"AAAA;;;;;GAKG;AACH;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* .register-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 50px 0;\n} */\n.register-wrapper h2 {\n  font-size: var(--f45);\n  font-weight: 700;\n  color: var(--dBlue);\n  text-align: left !important;\n}\n.register-wrapper {\n  /* width: 40%; */\n  padding: 50px;\n  /* box-shadow: 0px 0px 8px -3px #ccc; */\n  border-radius: 8px;\n}\n.register-wrapper h2 span {\n  color: var(--dPink);\n}\n.register-btn-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.register-wrapper button {\n  /* width: 30%; */\n  padding: 10px 25px;\n  background: var(--dBlue);\n  border: none;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 2px;\n  border-radius: 0;\n  text-transform: uppercase;\n  cursor: pointer;\n  border-radius: 30px;\n}\n.register-wrapper input,\n.register-wrapper select {\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  border: none;\n  border-radius: 50px;\n  border: 2px solid #c3c5f8;\n}\n.register-wrapper form input,\n.register-wrapper form select {\n  padding: 10px 20px !important;\n  width: 100%;\n  color: #000 !important;\n}\n\n.register-wrapper h4 {\n  font-size: 20px;\n  margin-bottom: 20px;\n  text-transform: capitalize;\n  color: var(--dBlue);\n}\n.register_login_signup {\n  background: rgb(195 197 248 / 10%);\n}\n.register_icons div {\n  display: block;\n  margin: 0 auto;\n  padding: 40px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  background: #f9f9fe;\n  border: 2px solid #c3c5f8;\n  border-radius: 50%;\n  text-align: center;\n  margin-top: -50px;\n}\n.register_icons {\n  border: 2px solid #c3c5f8;\n  padding: 0px 20px 40px;\n  border-radius: 15px;\n}\n.register_icons svg {\n  color: var(--dPink);\n}\n.register_icons h5 {\n  color: var(--dBlue);\n  font-weight: 700;\n  font-size: 24px;\n  margin: 15px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
